class CardsSlider {
	constructor( node, opts = {} ) {
		this.node = node;

		this.opts = Object.assign( {
			cards         : '.cards-slider__cards',
			wrap          : '.cards-slider__cards-wrap',
			kards         : '.kard',
			selectedClass : 'cards-slider__card--selected',
			activeClass   : 'cards-slider--active',
			navClass      : 'cards-slider__nav',
			navPrevClass  : 'cards-slider__prev',
			navNextClass  : 'cards-slider__next',
			offscreenClass: 'cards-slider__card--offscreen',
		}, opts );

		this.cards    = this.node.querySelector( this.opts.cards );
		this.wrap     = this.cards.querySelector( this.opts.wrap );
		this.kards    = Array.from( this.wrap.querySelectorAll( this.opts.kards ) );
		this.selected = -1;
		this.mode     = this.getMode();

		this.next    = this.next.bind(this);
		this.prev    = this.prev.bind(this);
		this.resize  = this.resize.bind(this);
		this.onFocus = this.onFocus.bind(this);

		this.lastEventType = null;

		[ 'mousedown', 'keydown' ].forEach( evt => document.addEventListener( evt, e => this.lastEventType = e.type ) )

		if ( this.kards.length > 1 ) {
			this.nav = document.createElement('nav');
			this.nav.className = this.opts.navClass;
			this.cards.parentNode.appendChild(this.nav);

			this.navPrev = document.createElement('button');
			this.navPrev.type = 'button';
			this.navPrev.className = this.opts.navPrevClass;
			this.navPrev.innerHTML = '<svg focusable="false" height="16" width="16" viewbox="0 0 100 100" role="img"><title>Previous</title><path fill="#fff" d="M100,55.5H22.1l33.8,31.4L48.4,95L0,50L48.4,5l7.5,8.1L22.1,44.5H100V55.5z"></path></svg>';
			this.navPrev.addEventListener( 'click', this.prev );
			this.nav.appendChild(this.navPrev);

			this.navNext = document.createElement('button');
			this.navNext.type = 'button';
			this.navNext.className = this.opts.navNextClass;
			this.navNext.innerHTML = '<svg focusable="false" height="16" width="16" viewbox="0 0 100 100" style="transform: rotate(180deg);" role="img"><title>Next</title><path fill="#fff" d="M100,55.5H22.1l33.8,31.4L48.4,95L0,50L48.4,5l7.5,8.1L22.1,44.5H100V55.5z"></path></svg>';
			this.navNext.addEventListener( 'click', this.next );
			this.nav.appendChild(this.navNext);

			if ( document.readyState === 'complete' ) {
				this.select( 0 );
			} else {
				window.addEventListener('load', () => this.select(0) );
			}

			this.node.addEventListener( 'focus', this.onFocus, true );
		}

		window.addEventListener('resize', this.resize);
		this.resize();
	}

	onFocus(e) {
		if ( this.lastEventType !== 'keydown' ) {
			return;
		}

		let node = e.target;

		while( node !== this.node ) {
			let index = this.kards.indexOf( node );

			if ( index > -1 && ! this.kards[ index ].classList.contains( this.selectedClass ) ) {
				e.preventDefault();
				return this.select( index );
			}

			node = node.parentNode;
		}
	}

	getMode() {
		if ( window.matchMedia( '(min-width: 1024px').matches ) {
			return 'desktop';
		}

		if ( window.matchMedia( '(min-width: 768px').matches ) {
			return 'tablet';
		}

		return 'mobile';
	}

	resize() {
		let mode = this.getMode();

		if ( this.mode !== mode ) {
			switch( mode ) {
				case 'desktop':
				case 'tablet':
					this.select(0);
					this.wrap.scrollTo(0, 0);
				break;
				case 'mobile':
					this.wrap.removeAttribute('style');
				break;
			}

			this.mode = mode;
		}
	}

	select( index ) {
		if ( index === this.selected ) {
			return;
		}

		if ( this.selected > -1 ) {
			this.kards[ this.selected ].classList.remove( this.opts.selectedClass );
		}
		this.selected = index;

		this.kards[ this.selected ].classList.add( this.opts.selectedClass );

		if ( this.selected > 0 ) {
			this.node.classList.add( this.opts.activeClass );
		} else {
			this.node.classList.remove( this.opts.activeClass );
		}

		if ( this.selected === 0 ) {
			this.navPrev.disabled = true;
			this.navNext.disabled = false;
		} else if ( this.selected === this.kards.length - 1 ) {
			this.navPrev.disabled = false;
			this.navNext.disabled = true;
		} else {
			this.navPrev.disabled = false;
			this.navNext.disabled = false;
		}

		let ontransitionend = () => {
			this.kards.forEach( ( kard, kardIndex ) => {
				if ( 'desktop' === this.mode ) {
					if ( kardIndex === index ) {
						kard.classList.remove( this.opts.offscreenClass );
						return;
					}

					const rect = kard.getBoundingClientRect();

					if ( rect.left < 0 || rect.left + rect.width > document.body.offsetWidth ) {
						kard.classList.add( this.opts.offscreenClass );
					} else {
						kard.classList.remove( this.opts.offscreenClass );
					}
				} else {
					kard.classList.remove( this.opts.offscreenClass );
				}
			} );

			this.wrap.removeEventListener( 'transitionend', ontransitionend );
		}

		this.wrap.addEventListener( 'transitionend', ontransitionend );

		const itemStyle = window.getComputedStyle( this.kards[ this.selected ] );
		this.wrap.style.transform = `translateX(-${ (parseInt( itemStyle.marginLeft, 10 ) + this.kards[this.selected].offsetWidth + parseInt( itemStyle.marginRight, 10 ) ) * this.selected }px)`;
	}

	next() {
		if ( this.selected < this.kards.length - 1 ) {
			this.select( this.selected + 1 );
		}
	}

	prev() {
		if ( this.selected > 0 ) {
			this.select( this.selected - 1 );
		}
	}
}

if ( ! CardsSlider.instances ) {
	CardsSlider.instances = Array.from( document.querySelectorAll( '.cards-slider' ) ).map( node => new CardsSlider( node ) );
}

export default CardsSlider;
